export default __webpack_public_path__ + "static/media/circle.08601148.svg";